var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0144 5.92826C14.0144 8.98767 11.5614 11.4408 8.49984 11.4408C5.43932 11.4408 2.98527 8.98767 2.98527 5.92826C2.98527 2.86886 5.43932 0.416748 8.49984 0.416748C11.5614 0.416748 14.0144 2.86886 14.0144 5.92826ZM8.49984 21.2501C3.98148 21.2501 0.166504 20.5157 0.166504 17.6823C0.166504 14.8479 4.00544 14.1396 8.49984 14.1396C13.0192 14.1396 16.8332 14.874 16.8332 17.7073C16.8332 20.5417 12.9942 21.2501 8.49984 21.2501Z",
    fill: "#00A0DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledprofile);
export default __webpack_public_path__ + "static/media/filledprofile.0c5f0a191654a6d60255c2619602dcf3.svg";
export { ForwardRef as ReactComponent };